import React from 'react';
import { xs_languageCode } from '../..';
import MainContext from '../../contexts/MainContext';
import BetslipAlt from '../../data/betslip-alt/BetslipAlt';
import { openPopup } from '../../data/sport-utils';
import { getMybetsPage, loadSessionToken } from '../../data/utils';
import { getLabel } from '../../InitData';

function openMyBets() {
    const mybetsPage = getMybetsPage(false);
    const url = `${process.env.PUBLIC_URL}${mybetsPage}`;
    openPopup(`${url}?token=${loadSessionToken()}&language=${xs_languageCode}`, getLabel('general.mybets'), 400, 800);
}

export default function BetslipContentAlt(props) {
    const mainContext = React.useContext(MainContext);

    function toggleFastbetPopup() {
        mainContext.toggleFastbetPopup();
    }

    return (
        <BetslipAlt toggleBetslip={props.toggleBetslip}
                 toggleFastbetPopup={toggleFastbetPopup}
                 toggleMyBets={openMyBets} />
    );
}
